import { ChatUpdateType } from "../enums/ChatEvents";
import { useSignalRConnection } from "./useSignalRConnection";

export const useChatUpdates = (
  chatId: string,
  callback: (type: ChatUpdateType, data: any) => void,
): void => {
  // const { getAccessToken } = useAuth();

  // useEffect(() => {
  //   getAccessToken().then((accessToken) => {
  //     const eventSource = new EventSource(
  //       `${import.meta.env.VITE_API_BASE_URL}/chats/${chatId}/events?access_token=${accessToken}`,
  //     );

  //     eventSource.onmessage = function (event) {
  //       try {
  //         const data = JSON.parse(event.data);
  //         callback(data.type, data);
  //       } catch (err) {
  //         console.error("Failed to parse SSE event:", err);
  //       }
  //     };

  //     return () => {
  //       eventSource.close();
  //     };
  //   });
  // }, [chatId, callback, getAccessToken]);

  useSignalRConnection({
    hubUrl: "/chatUpdatesHub",
    channelName: chatId,
    logPrefix: " for Chat",
    handleMessage: (name: string, data: string) => {
      callback(name as ChatUpdateType, JSON.parse(data));
    },
    dependencies: [chatId],
  });
};
